export default __webpack_public_path__ + "static/media/Cosumer Blue.5d94ea36.svg";